import {ValueObject} from '@s-ui/domain'

export class StructuredDataValueObject extends ValueObject {
  /**
   * See https://schema.org/docs/schemas.html for documentation
   * @param {Object} deps
   * @param {String} deps.@context
   * @param {Array} deps.@type
   * ...rest
   **/
}
